import { createLogger } from '@owl-lib/logger';
import { deserialize, fetchWrapper } from '../fetch';
import type { Notification } from './interface';
const logger = createLogger(__filename);

export const NOTIFICATIONS_PAGE_SIZE = 50;
const notificationApiClient = {
  fetch: async (): Promise<{
    notifications: Notification[];
    count: number;
  }> => {
    const url = new URL('/app/v1/notifications', API_BASE_URL);
    logger.trace('notificationApiClient.fetch()');

    url.searchParams.set('limit', `${NOTIFICATIONS_PAGE_SIZE}`);

    return deserialize(
      await fetchWrapper(url.href, { method: 'GET', credentials: 'include' })
    );
  },
  setStatus: async (data: {
    notification_id: string;
    is_read?: boolean;
    is_dismissed?: boolean;
  }): Promise<void> => {
    const url = new URL(
      `/app/v1/notifications/${data.notification_id}/status`,
      API_BASE_URL
    );
    logger.trace('notificationApiClient.setStatus()');
    return deserialize(
      await fetchWrapper(url.href, {
        method: 'PUT',
        credentials: 'include',
        headers: {
          'Content-type': 'application/json',
        },
        body: JSON.stringify({
          is_read: data.is_read,
          is_dismissed: data.is_dismissed,
        }),
      })
    );
  },
};

export default notificationApiClient;
